let botElement: HTMLElement | null = null

export function setBotElement(el: HTMLElement) {
  botElement = el
  ;(window as any).ai12zBot = el // optional fallback
}

export function getBotElement(): HTMLElement | null {
  return botElement || (window as any).ai12zBot || null
}

let ctaElement: HTMLElement | null = null

export function setCtaElement(el: HTMLElement) {
  ctaElement = el
  ;(window as any).ai12zCta = el // optional fallback
}
export function getCtaElement(): HTMLElement | null {
  return ctaElement || (window as any).ai12zCta || null
}

let carousel: HTMLElement | null = null
export function setItemListElement(el: HTMLElement) {
  carousel = el
  ;(window as any).carousel = el // optional fallback
}
export function getItemListElement(): HTMLElement | null {
  return carousel || (window as any).carousel || null
}
